import { render } from "./SimpleEventCreator.vue?vue&type=template&id=061aaeea"
import script from "./SimpleEventCreator.vue?vue&type=script&lang=js"
export * from "./SimpleEventCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__